/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { assetsService } from '../../../api/services/assetsService';
import { setAllActiveAssets } from '../../../infra/aggregates/myProfile/AssetsAggregates/activeAssetsSlice';
import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import AddAssetModalPresenter from './AddAssetModalPresenter';
import DTOAddAssetModal from './DTOAddAssetModal';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}
const AddAssetModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const companyId = useAppSelector((state) => state.authSlice.company_id);
  const [EmpAssetList, setEmpAssetList] = useState<[]>([]);
  const dispatch = useAppDispatch();

  const storeActiveAssets: any = useAppSelector(
    (state) => state.activeAssetsSlice.activeAssets,
  );
  async function callBackEmplist(data: []) {
    setEmpAssetList(data);
  }
  const getData = (data: any) => {
    assignAssets(data);
  };
  async function assignAssets(data: any) {
    if (selector) {
      const payload = {
        empId: selector.emp_id,
        company_id: companyId,
        assetIds: data.asset_id,
        assignDate: data.assign_Date,
      };

      await assetsService
        .assignAssets(payload)
        .then((response: any) => {
          if (response.response == 'success') {
            const tempAssets = [...storeActiveAssets];
            tempAssets.push(response?.data);
            dispatch(setAllActiveAssets(tempAssets));
            toast.success(trans('Added Successfully'));
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  }
  return (
    <>
      <DTOAddAssetModal setAllEmpAssetList={callBackEmplist} />
      <AddAssetModalPresenter
        callBackGetData={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allEmpAssetList={EmpAssetList}
        trans={trans}
      />
    </>
  );
};
export default AddAssetModalController;
